// extracted by mini-css-extract-plugin
module.exports = {"NotFound":"NotFoundPage_NotFound__2wZ3c"};